import React, { useState } from 'react';

export const useHasMounted = () => {
  // To solve SSR reconciliation issues when hydrate (layout broken misteriously) https://joshwcomeau.com/react/the-perils-of-rehydration/
  const [hasMounted, setHasMounted] = useState(false);
  React.useEffect(() => {
    setHasMounted(true);
  }, []);
  return hasMounted;
};

export function useStopTransitionsOnResize(duration: number) {
  React.useEffect(() => {
    if (!window) return;
    let resizeTimer: ReturnType<typeof setTimeout>;
    window.addEventListener('resize', () => {
      document.body.classList.add('resize-animation-stopper');
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(() => {
        document.body.classList.remove('resize-animation-stopper');
      }, duration);
    });
  }, [duration]);
}

export const scrollToChild = (component, childElement) => {
  const componentRect = component.getBoundingClientRect();
  const childRect = childElement.getBoundingClientRect();
  const offset = childRect.top - componentRect.top + component.scrollTop;

  component.scrollTo({
    top: offset,
    behavior: 'smooth',
  });
};
